import { TimelineMax, Bounce, Power2 } from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { SymbolData } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/config/SymbolData";
import { TextStyleConfig } from "../../../translation/TextStyleConfig";

export class SymbolMultiplyCounter extends PIXI.Text {

    private tl:TimelineMax;
    constructor(){
        super("")
        this.style.align = "center";
        this.style = TextStyleConfig.MULTIPLIER_TEXT;
        this.anchor.set(1, 0.5);
        this.position.x = SymbolData.DEFAULT_SYMBOL.DIM.WIDTH/4;
    }

    public apply(amount:number):void{
        if(!amount) return;
        this.scale.set(1,1);
        this.text = "x" + amount.toString();
        this.visible = amount > 1;
    }

    public addValue(amount:number,duration:number):TimelineMax{
        this.tl = Helper.timeLineKiller(this.tl!,new TimelineMax());
        if(amount <= 1) return this.tl;
        this.text = "x" + amount.toString();
        this.tl.fromTo(this.scale,duration,{x:1.55,y:1.55},{x:1,y:1, ease: Bounce.easeOut},0);
        this.tl.fromTo(this,duration,{alpha:0},{alpha:1, ease: Power2.easeOut},0);
        return this.tl;
    }

    public fadeOut(duration:number):TimelineMax{
        this.tl = Helper.timeLineKiller(this.tl!,new TimelineMax());
        this.tl.to(this,duration, {alpha:0});
        return this.tl;
    }
}